function createDatepicker(elementId, onSelect) {
    const datepicker = document.getElementById(elementId);
    const date = new Date();
    const currentMonth = date.getMonth();
    const currentYear = date.getFullYear();

    function renderCalendar(month, year) {
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();

        let html = '<table>';
        html += '<tr><th colspan="7">' + new Date(year, month).toLocaleString('default', { month: 'long' }) + ' ' + year + '</th></tr>';
        html += '<tr><th>Su</th><th>Mo</th><th>Tu</th><th>We</th><th>Th</th><th>Fr</th><th>Sa</th></tr>';

        let day = 1;
        for (let i = 0; i < 6; i++) {
            html += '<tr>';
            for (let j = 0; j < 7; j++) {
                if (i === 0 && j < firstDay.getDay()) {
                    html += '<td></td>';
                } else if (day > daysInMonth) {
                    html += '<td></td>';
                } else {
                    html += `<td data-date="${year}-${month + 1}-${day}">${day}</td>`;
                    day++;
                }
            }
            html += '</tr>';
            if (day > daysInMonth) {
                break;
            }
        }
        html += '</table>';
        datepicker.innerHTML = html;

        datepicker.querySelectorAll('td[data-date]').forEach(cell => {
            cell.addEventListener('click', () => {
                const selectedDate = new Date(cell.dataset.date);
                onSelect(selectedDate);
                datepicker.style.display = 'none';
            });
        });
    }

    renderCalendar(currentMonth, currentYear);
    return renderCalendar;
}

const checkInDate = document.getElementById('checkInDate');
const checkOutDate = document.getElementById('checkOutDate');
const checkInDatepicker = document.getElementById('checkInDatepicker');
const checkOutDatepicker = document.getElementById('checkOutDatepicker');

const renderCheckInCalendar = createDatepicker('checkInDatepicker', (date) => {
    checkInDate.textContent = date.toLocaleDateString();
});

const renderCheckOutCalendar = createDatepicker('checkOutDatepicker', (date) => {
    checkOutDate.textContent = date.toLocaleDateString();
});

checkInDate.addEventListener('click', () => {
    checkInDatepicker.style.display = 'block';
    checkOutDatepicker.style.display = 'none';
});

checkOutDate.addEventListener('click', () => {
    checkOutDatepicker.style.display = 'block';
    checkInDatepicker.style.display = 'none';
});

document.addEventListener('click', (event) => {
    if (!checkInDate.contains(event.target) && !checkInDatepicker.contains(event.target)) {
        checkInDatepicker.style.display = 'none';
    }
    if (!checkOutDate.contains(event.target) && !checkOutDatepicker.contains(event.target)) {
        checkOutDatepicker.style.display = 'none';
    }
});

const guestCount = document.getElementById('guestCount');
const decreaseGuests = document.getElementById('decreaseGuests');
const increaseGuests = document.getElementById('increaseGuests');

let guests = 0;

decreaseGuests.addEventListener('click', () => {
    if (guests > 0) {
        guests--;
        guestCount.textContent = guests;
    }
});

increaseGuests.addEventListener('click', () => {
    guests++;
    guestCount.textContent = guests;
});